import React from "react";
import { Table as AntTable, Menu, Pagination, Select, Col, Row } from "antd";
import { Arrow } from "../../../components/Arrow";
import styles from "../../styles/Registers.module.css";
import { ActionsTableColCommon } from "./ActionsTableColCommon";
import { AddOrEditPatient } from "../../patitents/components/AddOrEditPatient";

export const Table = ({
  medicalReports,
  loading,
  totalRows,
  currentPage,
  pageSize,
  onPaginationChange,
  onPageSizeChange,
  onEdit,
  onDelete,
  orderValue,
  setOrderValue,
  showSaveBtn

}) => {

  const { Option } = Select;
  const currentStateFrom =
    currentPage !== 1 ? (currentPage - 1) * pageSize + 1 : 1;
  const currentStateTo =
    currentPage * pageSize < totalRows ? currentPage * pageSize : totalRows;
  var showing;
  if (totalRows) {
    showing =
      "Prikazano " +
      String(currentStateFrom).replace(/^0+/, "") +
      "-" +
      String(currentStateTo).replace(/^0+/, "") +
      " od " +
      totalRows;
  } else {
    showing = "";
  }

  const orderingFunction = (columnKey) => {
    if (orderValue !== columnKey) {
      setOrderValue(columnKey);
    } else {
      setOrderValue("-" + columnKey);
    }
  };

  const renderTitle = (name, title) => {
    return (
      <Row>
        <Col xs={23} sm={23}>
          <span>{title}</span>
        </Col>

				{/*
        <Col xs={1} sm={1}>
          {!orderValue.includes(name) ? (
            <Row style={{ marginTop: "-5px" }}>
              <Col xs={24} sm={24} style={{ height: "10px" }}>
                <Arrow rotate={true} color={"#bbbbc1"} />
              </Col>
              <Col xs={24} sm={24}>
                <Arrow rotate={false} color={"#bbbbc1"} />
              </Col>
            </Row>
          ) : orderValue === name ? (
            <Row>
              <Col xs={24} sm={24}>
                <Arrow rotate={false} color={"#1abc9c"} />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs={24} sm={24} style={{ height: "10px" }}>
                <Arrow rotate={true} color={"#1abc9c"} />
              </Col>
            </Row>
          )}
        </Col>
				*/}
      </Row>
    );
  };

  const renderActions = (record) => {
    return (
      <ActionsTableColCommon
        medicalReport={record}
        onEdit={onEdit}
        onDelete={onDelete}
        showSaveBtn= {showSaveBtn}
      />
    );
  };

  const columns = [
    {
      title: renderTitle("id", "#"),
      key: "id",
      dataIndex: "id",
//			defaultSortOrder: "descend",
			sorter: (a, b) => a.id - b.id,
    },

    {
      title: renderTitle("patient", "Pacijent"),
      key: "patient",
      dataIndex: "patient",
      render: (record) => record.first_name + " " + record.last_name,
			sorter: (a, b) => {
				const nameA = (a?.patient?.first_name + " " + a?.patient?.last_name).toLowerCase();
				const nameB = (b?.patient?.first_name + " " + b?.patient?.last_name).toLowerCase();

				return nameA.localeCompare(nameB);
			}
    },
    {
      title: renderTitle("report_type", "Pregled"),
      key: "report_type",
      dataIndex: "report_type",
      render: (record) => record.name,
			sorter: (a, b) => {
				return a?.report_type?.name.localeCompare(b?.report_type?.name)
			}
    },
    {
      title: renderTitle("date_start", "Termin pregleda"),
      key: "date",
      dataIndex: "date",
      render: (date) => {
        console.log(date,'data')
        return(
        <>
        <p>{date.split(" ")[0]}<br></br>{date.split(" ")[1]}</p>
        </>)
      },
			sorter: (a, b) => {
				const timeA = new Date(a.date_start).getTime();
				const timeB = new Date(b.date_start).getTime();


				return timeA - timeB;
			}
    },
    {
      title: "Doktor",
      key: "doctor",
      dataIndex: "doctor",
      render: (record) => record.first_name + " " + record.last_name,
    },
    {
      title: "Akcije",
      key: "action",
      render: (record) => renderActions(record),
      width: 120,
    },
  ];

  return (
    <div>
      <div className={styles.registersTable}>
        <AntTable
          columns={columns}
          dataSource={medicalReports}
          loading={loading}
          locale={{ emptyText: "Nema rezultata" }}
          pagination={false}
          scroll={{ x: true }}
          rowKey={({ id }) => id}
        />
      </div>
      <div className={styles.tableFooter}>
        <div className={styles.paginationDesription}>{showing}</div>
        <div
          className={
            "ant-table-pagination ant-table-pagination-right " +
            styles.paginationBackground
          }
        >
          <Pagination
            total={totalRows}
            current={currentPage}
            onChange={onPaginationChange}
            showSizeChanger={false}
            pageSize={pageSize}
          />
          <Select
            className={styles.pageSizeButton}
            defaultValue={String(pageSize)}
            style={{ width: 130, alignSelf: "end" }}
            onChange={(e) => onPageSizeChange(e)}
          >
            <Option value="10">10 po strani</Option>
            <Option value="20">20 po strani</Option>
            <Option value="50">50 po strani</Option>
            <Option value="100">100 po strani</Option>
          </Select>
        </div>
      </div>
    </div>
  );
};
